<template>
  <v-menu offset-y content-class="permission-scope-menu">
    <template #activator="{ on, attrs }">
      <button
        type="button"
        class="inline-flex items-center gap-0.5 px-1.5 py-0.5 rounded-md text-[10px] font-semibold border transition-colors shrink-0 focus:outline-none cursor-pointer"
        :class="disabled
          ? 'opacity-70 bg-slate-50 text-slate-500 border-slate-200 hover:bg-slate-100'
          : 'bg-indigo-50 text-indigo-700 border-indigo-200 hover:bg-indigo-100'"
        :aria-label="$t('permission_scope') + ': ' + $t(meta.labelKey)"
        v-bind="attrs"
        v-on="on"
      >
        <v-icon size="11" :color="meta.color">{{ meta.icon }}</v-icon>
        {{ $t(meta.labelKey) }}
        <v-icon size="10" color="#64748b">{{ disabled ? 'mdi-lock-outline' : 'mdi-chevron-down' }}</v-icon>
      </button>
    </template>
    <v-list dense class="py-1 bg-white">
      <div class="px-3 py-1 text-[10px] font-semibold text-slate-400 uppercase tracking-wider">
        {{ $t('permission_scope_picker_title') }}
      </div>
      <v-list-item
        v-for="s in SCOPE_OPTIONS"
        :key="s.value"
        :class="s.value === current ? 'bg-indigo-50' : ''"
        :disabled="disabled"
        @click="onSelect(s.value)"
      >
        <v-list-item-icon class="mr-2">
          <v-icon size="16" :color="s.color">{{ s.icon }}</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="text-sm font-medium">{{ $t(s.labelKey) }}</v-list-item-title>
          <v-list-item-subtitle class="text-xs text-slate-500">
            {{ $t(s.labelKey + '_hint') }}
          </v-list-item-subtitle>
        </v-list-item-content>
        <v-icon v-if="s.value === current" size="18" color="#4f46e5">mdi-check</v-icon>
      </v-list-item>
      <div v-if="disabled" class="px-3 py-1.5 text-[10px] text-amber-700 bg-amber-50 border-t border-amber-100">
        <v-icon size="11" color="#b45309">mdi-lock-outline</v-icon>
        {{ $t('permission_preview_readonly') }}
      </div>
    </v-list>
  </v-menu>
</template>

<script>
import { SCOPE, SCOPE_OPTIONS, scopeMeta } from '@/js/permission-helpers'

export default {
  name: 'PermissionScopeChip',
  props: {
    // number | null — null/undefined 視為 All
    scope: { type: [Number, String], default: null },
    disabled: { type: Boolean, default: false }
  },
  data () {
    return { SCOPE_OPTIONS }
  },
  computed: {
    current () {
      // 提供選單的「已選中」比較用
      return (this.scope === null || this.scope === undefined) ? SCOPE.ALL : Number(this.scope)
    },
    meta () {
      // 讓 helper 集中處理 null/undefined/string → option 的轉換
      return scopeMeta(this.scope)
    }
  },
  methods: {
    onSelect (value) {
      if (this.disabled) return
      if (value === this.current) return
      this.$emit('change', value)
    }
  }
}
</script>
